export enum GameType {
  daily = 'daily',
  theme = 'theme'
}

export const allGameTypes: GameType[] = Object.values(GameType);
